import { getCookie } from '../shared/cookies';

document.addEventListener('DOMContentLoaded', function () {
  function getErrorMessageModal() {
    const error = getCookie('juno_error');
    if (error) {
      const errorMessageElement = document.querySelector('#errorMessage');
      const errorModalElement = document.querySelector('#errorModal');

      if (errorMessageElement) {
        errorMessageElement.textContent = error;
      }

      if (errorModalElement) {
        const errorModal = new bootstrap.Modal(errorModalElement);

        errorModal.show();
      }

      document.cookie =
        'juno_error=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
  }
  getErrorMessageModal();

  const headerNavbarWrap = document.querySelector('#headerNavbarWrap');
  const footerHat = document.querySelector('#footer-hat');
  const colophon = document.querySelector('#colophon');
  const formWrap = document.querySelector('#form-wrap');

  if (!headerNavbarWrap || (!footerHat && !colophon)) {
    console.error('Required elements are missing in the DOM.');
    return;
  }

  const targetElement = footerHat || colophon;

  function getVerticalHeight() {
    return window.innerHeight;
  }

  function updateHeaderClass() {
    const verticalHeight = getVerticalHeight();
    const rect = targetElement.getBoundingClientRect();
    const distanceFromTop = rect.top;

    if (distanceFromTop <= 200) {
      headerNavbarWrap.classList.add('nav-viewport-top');
    } else {
      headerNavbarWrap.classList.remove('nav-viewport-top');
    }

    if(formWrap) {
      if (distanceFromTop <= verticalHeight) {
        formWrap.classList.remove('form-height');
      } else {
        formWrap.classList.add('form-height');
      } 
    }
  }

  // Attach the scroll event listener
  window.addEventListener('scroll', updateHeaderClass);

  // Initial check for the loaded position
  updateHeaderClass();
});
